export default __webpack_public_path__ + "static/media/bg-loading-v2.5c25bc28.jpg";